import { render, staticRenderFns } from "./homeworkIndex.vue?vue&type=template&id=2a3ea5ba&scoped=true"
import script from "./homeworkIndex.vue?vue&type=script&lang=js"
export * from "./homeworkIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ea5ba",
  null
  
)

export default component.exports